import { useQuery } from '@tanstack/react-query'
import { adminUsersApi } from '../../services/api'
import { userHasActiveAssignmentToSchool } from '../../utils/teacherSchoolScope'

const MIN_QUERY = 2

export function useTeacherDirectory(params: {
  query: string
  schoolId?: string
  /** When loading options for a known selection, request a wider page so the match is included. */
  pageSize?: number
  enabled?: boolean
}) {
  const { query, schoolId, pageSize = 10, enabled = true } = params

  return useQuery({
    queryKey: ['accounts', 'teacher-directory', { query, schoolId, pageSize }],
    queryFn: async () => {
      const results = await adminUsersApi.listUsers({
        role: 'TEACHER',
        search: query.length >= MIN_QUERY ? query : undefined,
        school_id: schoolId,
        page_size: pageSize,
      })

      const scoped = schoolId
        ? results.filter(user => userHasActiveAssignmentToSchool(user, schoolId))
        : results

      return scoped.map(user => ({
        id: user.id,
        label:
          [user.first_name?.trim(), user.last_name?.trim()].filter(Boolean).join(' ') || user.email,
        email: user.email,
      }))
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  })
}
